import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Philosophy from "@/components/Philosophy";
import Treatments from "@/components/Treatments";
import Results from "@/components/Results";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import EnquiryModal from "@/components/EnquiryModal";

export default function App() {
  const [enquiry, setEnquiry] = useState({ open: false, treatment: "" });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const openEnquiry = (treatment = "") => setEnquiry({ open: true, treatment });
  const closeEnquiry = () => setEnquiry({ open: false, treatment: "" });

  return (
    <div className="App bg-cream text-ink overflow-x-hidden">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar onEnquire={() => openEnquiry()} />
      <main>
        <Hero onEnquire={() => openEnquiry()} />
        <Marquee />
        <Philosophy />
        <Treatments onEnquire={openEnquiry} />
        <Results />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <EnquiryModal
        open={enquiry.open}
        treatment={enquiry.treatment}
        onClose={closeEnquiry}
      />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#2C2623",
            color: "#F9F6F0",
            border: "1px solid #C06C4C",
          },
        }}
      />
    </div>
  );
}
